module.exports = __webpack_public_path__ + "img/campaign-view-header.2e28c0bb.png";